export default __webpack_public_path__ + "static/media/details1.a5199e7a.jpg";